import React from "react";
import {styled, keyframes, css} from "styled-components";

// Sweeps in the first ~5% of the 30s cycle (~1.5s), then idles
const shimmerOnce = keyframes`
  0%   { transform: translateX(-100%); }
  5%   { transform: translateX(100%); }
  100% { transform: translateX(100%); }
`;

const PillButton = styled.button<{$active: boolean}>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 12px 0 10px;
  border-radius: 999px;
  border: none;
  cursor: ${p => (p.$active ? "pointer" : "default")};
  font: 600 12px/1 -apple-system, system-ui, sans-serif;
  flex: 0 0 auto;
  white-space: nowrap;
  background: ${p =>
    p.$active ? "linear-gradient(90deg, #6d28d9, #2563eb)" : "#cbd5e1"};
  color: #fff;
  box-shadow: ${p =>
    p.$active ? "0 1px 2px rgba(37, 99, 235, 0.25)" : "none"};

  ${p =>
    p.$active &&
    css`
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.45),
          transparent
        );
        animation: ${shimmerOnce} 30s linear infinite;
        pointer-events: none;
      }

      @media (prefers-reduced-motion: reduce) {
        &::before {
          display: none;
        }
      }
    `}
`;

const Star = styled.span`
  font-size: 14px;
  line-height: 1;
`;

interface ReasoningProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  message: any;
  onOpen: () => void;
}

export function Reasoning({message, onOpen}: ReasoningProps) {
  const hasReasoning = Boolean(message?.metadata?.detailed_response);

  return (
    <PillButton
      $active={hasReasoning}
      onClick={hasReasoning ? onOpen : undefined}
      disabled={!hasReasoning}
      aria-label={hasReasoning ? "Show reasoning" : undefined}
      aria-disabled={!hasReasoning || undefined}
    >
      <Star>✦</Star>
      {hasReasoning ? "Reasoning" : "No reasoning"}
    </PillButton>
  );
}
